/* global jQuery COMPONENTS */

COMPONENTS.ComponentBlog = (function ($) {
  function ComponentBlog ($component) {
    this.$component = $component;
    this.contentIndex = $component.data('ecs-content-index');

    this.$blogGrid = this.$component.find('[data-ecs-components-blog-grid]')
    this.$blogItems = this.$blogGrid.find('[data-ecs-components-control="blog-article"]')
    this.$loadMore = this.$component.find('[data-ecs-components-control="load-more"]')

    this.$blogParams = this.$component.find('[data-ecs-components-control="blog-params"]')

    this.nextPage = this.$blogParams.data('ecs-components-blog-current-page')
    this.maxPages = this.$blogParams.data('ecs-components-blog-max-pages')
    this.query = this.$blogParams.data('ecs-components-blog-query')
    this.index = this.$blogParams.data('ecs-components-blog-index')
    this.postsPerPage = this.$blogParams.data('ecs-components-blog-posts-per-page')
    this.nonce = this.$blogParams.data('ecs-components-blog-nonce')

    this.$filters = this.$component.find('[data-ecs-components-control="filter-blog-category"]')

    this.pageID = this.$blogGrid.data('ecs-components-page-id')
  }

  ComponentBlog.prototype.calcCardHeights = function (grid) {
    if (typeof grid == 'undefined') {
      return;
    }

    const $blogItems = $(grid).find('[data-ecs-components-control="blog-article"]')
    let tallestCardHeight = 0
    const viewportTablet = $(window).width() >= 769

    $blogItems.each(function () {
      const cardWrap = $(this).children('.ecs__component-blog__card__wrap')
      cardWrap.css('min-height', '')
    })

    // Loop over the article cards to find the card with the greatest height
    $blogItems.each(function () {
      const cardWrap = $(this).children('.ecs__component-blog__card__wrap')
      tallestCardHeight = Math.max(tallestCardHeight, cardWrap.outerHeight())
    })

    // Test if viewport is tablet or greater
    if (viewportTablet) { // Tablet or above
      $blogItems.each(function () {
        const cardWrap = $(this).children('.ecs__component-blog__card__wrap')
        cardWrap.css('min-height', (tallestCardHeight + 'px'))
      })
    } else { // Mobile
      $blogItems.each(function () {
        const cardWrap = $(this).children('.ecs__component-blog__card__wrap')
        cardWrap.css('min-height', '')
      })
    }

    $(grid).isotope('layout')
  }

  ComponentBlog.prototype.initGrid = function () {
    if (this.$blogGrid.length < 1) {
      return false
    }

    this.$blogGrid.each(function () {
      const $grid = $(this)

      $grid.imagesLoaded(function () {
        $grid.isotope({
          itemSelector: '[data-ecs-components-control="blog-article"]',
          layoutMode: 'masonry'
        })
      })
    })
  }

  ComponentBlog.prototype.initLoadMore = function () {
    if (this.$loadMore.length < 1) {
      return false
    }

    const component = this

    this.$loadMore.click(function (e) {
      e.preventDefault()

      // Don't try to load if we are already loading
      if (component.$loadMore.hasClass('loading')) {
        return false
      }

      // Don't try to load if we are already at the max number of pages
      if (component.nextPage > component.maxPages) {
        return false
      }

      component.getArticles()
    })
  }

  ComponentBlog.prototype.initFilters = function () {
    if (this.$filters.length < 1) {
      return false
    }

    const component = this

    component.$filters.each(function () {
      const $filter = $(this)

      $filter.click(function () {
        component.$filters.each(function () {
          $(this).removeClass('components__active')
        })

        $filter.addClass('components__active')

        const filterCategory = $(this).data('ecs-filter-blog-category')

        if (filterCategory !== '*') {
          component.query.tax_query = [{
            taxonomy: 'category', field: 'term_id', terms: [filterCategory]
          }]
        } else {
          component.query.tax_query = []
        }

        // Clear the grid before loading new articles
        component.$blogGrid.isotope('remove', component.$blogGrid.isotope('getItemElements'))
        component.$blogGrid.empty();
        component.nextPage = 1

        // Set a flag to indicate this is a filter change (not load more)
        component.isFilterChange = true

        component.getArticles()
      })
    })
  }

  ComponentBlog.prototype.paramFilter = function ($category) {
    // clicks the tab filter on whatever blog category is in the URL
    if ($category) $('[data-ecs-filter-blog-category-slug="' + $category + '"]').click()
  }

  ComponentBlog.prototype.getArticles = function () {
    const component = this

    component.$loadMore.addClass('loading')

    component.query.posts_per_page = component.postsPerPage

    const requestArray = {
      action: 'component_blog_load_more_posts',
      nonce: component.nonce,
      query: component.query,
      page: component.nextPage,
      pages: component.maxPages,
      page_id: component.pageID,
      index: component.index,
      content_index: component.contentIndex
    }

    $.post(COMPONENTS.ajaxURL, requestArray).done(function (_data) {
      if (_data) {
        component.injectArticles(_data, component.isFilterChange)
        // Reset the flag after use
        component.isFilterChange = false
      }
    })
  }

  // Update injectArticles to accept a replace flag
  ComponentBlog.prototype.injectArticles = function (_data, replace) {
    const component = this
    // The endpoint responds with an application/json Content-Type, so jQuery
    // auto-parses the body into an object. Only parse manually if we ever
    // receive a raw JSON string (e.g. a different Content-Type upstream).
    const data = typeof _data === 'string' ? JSON.parse(_data) : _data

    if (replace) {
      // Remove all current items before adding new ones
      component.$blogGrid.isotope('remove', component.$blogGrid.isotope('getItemElements'))
    }

    for (let i = 0; i < data.articles.length; i++) {
      const $item = $(data.articles[i])
      component.$blogGrid.append($item).isotope('appended', $item)
    }

    component.$blogGrid.imagesLoaded().done(function () {
      setTimeout(function () {
        component.calcCardHeights(component.$blogGrid)
      }, 250)
    })

    component.nextPage = parseInt(component.nextPage + 1)
    component.maxPages = parseInt(data.max_pages)

    if (component.nextPage > component.maxPages) {
      component.$loadMore.hide()
    } else {
      component.$loadMore.show()
    }

    component.$loadMore.removeClass('loading')
  }

  // Init the Blog Component
  ComponentBlog.prototype.init = function () {
    const component = this
    let $params = new URLSearchParams(window.location.search)
    let $categoryParam = $params.get('category')

    this.initGrid()
    $(window).on('resize', function () {
      component.calcCardHeights(component.$blogGrid)
    })

    component.$blogGrid.imagesLoaded().done(function () {
      // FIXME: There is a race condition happening here
      // I've added a setTimeout (250ms) to resolve, for now
      setTimeout(function () {
        component.calcCardHeights(component.$blogGrid)
      }, 250)
    })

    if ($categoryParam) {
      // FIXME: There is a race condition happening here
      // I've added a setTimeout (50ms) to resolve, for now
      setTimeout(function () {
        component.paramFilter($categoryParam)
      }, 50)
    }

    this.initLoadMore()
    this.initFilters()
  }

  return ComponentBlog
})(jQuery)

document.addEventListener('components_init', function () {
  var $ = window.jQuery;
  $('[data-ecs-component="component-blog"]').each(function () {
    const $component = $(this);
    const instance = new COMPONENTS.ComponentBlog($component);
    instance.init();
    // Optionally store instances by index if you need to reference them later
    if (!COMPONENTS.componentBlogInstances) COMPONENTS.componentBlogInstances = {};
    COMPONENTS.componentBlogInstances[$component.data('ecs-content-index')] = instance;
  });
});
